var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#274781"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0761 9.08049C9.39801 9.11057 8.9277 9.17893 8.4902 9.31564C7.80114 9.53166 7.3609 9.95549 7.16676 10.5926C7.01911 11.0738 7.01637 11.1094 7.00543 13.5348C6.9945 15.8891 7.00543 16.2199 7.11207 16.7422C7.23239 17.3356 7.42653 17.7321 7.76559 18.0766C8.31247 18.6317 9.01247 18.8586 10.3632 18.9242C10.7679 18.9434 12.1953 18.9488 14.5195 18.9406C18.2574 18.927 18.3148 18.927 18.9218 18.7985C20.0019 18.5715 20.5789 18.0274 20.8332 16.9938C20.9836 16.3895 20.9863 16.3184 20.9863 13.7809C20.9863 12.009 20.9781 11.3856 20.9507 11.2024C20.7922 10.1196 20.3957 9.60002 19.5097 9.31564C19.0777 9.17619 18.632 9.1133 17.8363 9.07775C17.1718 9.04768 10.7597 9.05041 10.0761 9.08049ZM13.2562 12.1375C14.1777 12.5996 16.0152 13.5703 16.0726 13.625C16.264 13.8 16.2586 14.0653 16.0589 14.2485C15.9687 14.3332 13.0785 15.8481 12.9336 15.8863C12.7504 15.9356 12.5425 15.8371 12.4578 15.6567C12.4195 15.5746 12.414 15.3805 12.414 13.9231V12.2852L12.4769 12.1922C12.5097 12.143 12.5808 12.0719 12.63 12.0391C12.7804 11.9379 12.8925 11.9543 13.2562 12.1375Z",
    fill: "#ABC452"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2177fe70f4fce2fd05783948e95e454b.svg";
export { ForwardRef as ReactComponent };